module.exports = __webpack_public_path__ + "static/media/runway_lookbook.9d645044.jpg";